import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { authSlice, AuthSlice } from './slices/authSlice';
import { appSlice, AppSlice } from './slices/appSlice';
import { patientsSlice, PatientsSlice } from './slices/patientsSlice';
import { documentsSlice, DocumentsSlice } from './slices/documentsSlice';
import { tasksSlice, TasksSlice } from './slices/tasksSlice';
import { intakeSlice, IntakeSlice } from './slices/intakeSlice';
import { toastSlice, ToastSlice } from './slices/toastSlice';
import { payorSlice, PayorSlice } from './slices/payorSlice';
import { rogerDocSlice, RogerDocSlice } from './slices/rogerDocSlice';
import {
  agencyInsuranceSlice,
  AgencyInsuranceSlice,
} from './slices/agencyInsuranceSlice';
import {
  agencyClinicSlice,
  AgencyClinicSlice,
} from './slices/agencyClinicSlice';
import { noaSlice, NOASlice } from './slices/noaSlice';
import {
  oasisManagerSlice,
  OASISManagerSlice,
} from './slices/oasisManagerSlice';

export type StoreState = AuthSlice &
  AppSlice &
  PatientsSlice &
  DocumentsSlice &
  TasksSlice &
  IntakeSlice &
  ToastSlice &
  PayorSlice &
  RogerDocSlice &
  AgencyInsuranceSlice &
  AgencyClinicSlice &
  NOASlice &
  OASISManagerSlice;

export const useStore = create<StoreState>()(
  devtools(
    persist(
      (...a) => ({
        ...authSlice(...a),
        ...appSlice(...a),
        ...patientsSlice(...a),
        ...documentsSlice(...a),
        ...tasksSlice(...a),
        ...intakeSlice(...a),
        ...toastSlice(...a),
        ...payorSlice(...a),
        ...rogerDocSlice(...a),
        ...agencyInsuranceSlice(...a),
        ...agencyClinicSlice(...a),
        ...noaSlice(...a),
        ...oasisManagerSlice(...a),
      }),
      {
        name: 'roger-emr-store',
        partialize: state => ({
          user: state.user,
          isAuthenticated: state.isAuthenticated,
          isSidebarCollapsed: state.isSidebarCollapsed,
          intakeManagerFilters: state.intakeManagerFilters,
          noaManagerFilters: state.noaManagerFilters,
          oasisManagerFilters: state.oasisManagerFilters,
        }),
      }
    ),
    {
      name: 'roger-emr-store',
    }
  )
);
